module.exports = __webpack_public_path__ + "static/media/arrow-button-right-off-2.38bf6401.svg";